import { BoxProps, DropProps } from 'grommet'

export const emotionDropProps: DropProps = {
  round: 'small',
  margin: 'small',
  elevation: 'small',
  responsive: false,
  background: { color: 'white' },
}

export const emotionBoxProps: BoxProps = {
  pad: 'small',
  round: 'small',
  elevation: 'small',
  responsive: false,
  background: { color: 'white' },
}
